export const FEE_TOOLTIP_POPPER_MODIFIERS = [
  {
    name: 'preventOverflow',
    options: {
      boundary: 'viewport',
      altAxis: true,
      padding: 8,
    },
  },
  {
    name: 'flip',
    options: {
      fallbackPlacements: ['top-start', 'bottom-end', 'top-end'],
      boundary: 'viewport',
    },
  },
];
